import { render, staticRenderFns } from "./UserDetailsAdministrationTabsLockUser.vue?vue&type=template&id=9b79c470&"
import script from "./UserDetailsAdministrationTabsLockUser.vue?vue&type=script&lang=js&"
export * from "./UserDetailsAdministrationTabsLockUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports